import { render, staticRenderFns } from "./RegisteredClassroomTable.vue?vue&type=template&id=34d17b65&scoped=true"
import script from "./RegisteredClassroomTable.vue?vue&type=script&lang=js"
export * from "./RegisteredClassroomTable.vue?vue&type=script&lang=js"
import style0 from "./RegisteredClassroomTable.vue?vue&type=style&index=0&id=34d17b65&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d17b65",
  null
  
)

export default component.exports